import { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const DocumentTitle = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('home.headerTitle');
  }, [t]);

  return null;
};

export default DocumentTitle;
